import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { EstadoDocumentoElectronico } from '../shared/object/IDocumento_electronico.model';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentoElectronicoService {
  constructor(private gqlclient: GraphQLClient) {}

  obtenerEmitidosDetalle(
    inputParams: {
      empresa_rut: number;
      tipo_dte_codigo: number;
      estadoDocumento: EstadoDocumentoElectronico;
      rutCliente?: number;
      periodo: Date;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $tipo_dte_codigo: Decimal, $estadoDocumento: String, $rutCliente: Decimal, $periodo: Date, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documentoElectronico {
              obtenerEmitidosDetalle(
                empresa_rut: $empresa_rut
                tipo_dte_codigo: $tipo_dte_codigo
                estadoDocumento: $estadoDocumento
                periodo: $periodo
                rutCliente: $rutCliente
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    tipoDescripcionAbreviada
                    folio
                    fecha
                    rut
                    razon_social
                    monto
                    intento_envio_al_sii
                    respuesta_sii
                    envio_rec
                    acuse_recibo
                    recepcion_mercaderia
                    respuesta_comercial
                    id_lsoft
                    tipo_dte_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.obtenerEmitidosDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerEmitidosDetalleExcel(
    inputParams: {
      empresa_rut: number;
      tipo_dte_codigo: number;
      estadoDocumento: EstadoDocumentoElectronico;
      rutCliente?: number;
      periodo: Date;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $tipo_dte_codigo: Decimal, $estadoDocumento: String, $rutCliente: Decimal, $periodo: Date) {
            documentoElectronico {
              obtenerEmitidosDetalleExcel(
                empresa_rut: $empresa_rut, 
                tipo_dte_codigo: $tipo_dte_codigo, 
                estadoDocumento: $estadoDocumento,
                rutCliente: $rutCliente, 
                periodo: $periodo
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.obtenerEmitidosDetalleExcel;
        callback({ mensajes, respuesta });
      }
    );
  }

  // EnviarMailEmisor(inputParams: {
  //   empresa_rut: number
  //   folio: number
  //   type: 1
  // }, callback: Function) {
  //   this.gqlclient.query(
  //     {
  //       query: gql`
  //       query ($empresa_rut: Decimal, $folio: Decimal) {
  //         documentoElectronico {
  //           enviarMailEmisor(empresa_rut: $empresa_rut, folio: $folio) {
  //             mensajes {
  //               codigo
  //               texto
  //               tipo
  //             }
  //             respuesta
  //           }
  //         }
  //       }
  //       `,
  //       variables: inputParams,
  //       fetchPolicy: 'no-cache',
  //     },
  //     function (response) {
  //       const { mensajes, respuesta } = response.data.documentoElectronico.enviarMailEmisor
  //       callback({ mensajes, respuesta })
  //     }
  //   );
  // }

  obtenerRecibidosIntercambioEmpresas(
    inputParams: {
      empresa_rut: number;
      desde: Date;
      hasta: Date;
      tipo_dte_codigo: number;
      statusDocumento: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $desde: Date, $hasta: Date, $tipo_dte_codigo: Decimal, $statusDocumento: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documentoElectronico {
              obtenerRecibidosIntercambioEmpresas(
                empresa_rut: $empresa_rut
                desde: $desde
                hasta: $hasta
                tipo_dte_codigo: $tipo_dte_codigo
                statusDocumento: $statusDocumento
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    fecha
                    folio
                    rut
                    razon_social
                    monto_neto
                    monto_exento
                    impuesto_adicional
                    total_bruto
                    intento_envio_al_sii
                    acuse_recibo
                    recepcion_mercaderia
                    respuesta_comercial
                    id_lsoft
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.obtenerRecibidosIntercambioEmpresas;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerRecibidosImportacion(
    inputParams: {
      empresa_rut: number;
      desde: Date;
      hasta: Date;
      tipo_dte_codigo: number;
      statusDocumento: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
      retornaExcel: boolean;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query (
            $empresa_rut: Decimal
            $desde: Date
            $hasta: Date
            $tipo_dte_codigo: Decimal
            $statusDocumento: Decimal
            $retornaExcel: Boolean
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            documentoElectronico {
              obtenerRecibidosImportacion(
                empresa_rut: $empresa_rut
                desde: $desde
                hasta: $hasta
                tipo_dte_codigo: $tipo_dte_codigo
                statusDocumento: $statusDocumento
                retornaExcel: $retornaExcel
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    fecha
                    folio
                    rut
                    rut_emisor
                    rut_receptor
                    tipo_dte_codigo
                    razon_social
                    monto_neto
                    monto_exento
                    impuesto_adicional
                    total_bruto
                    envio_rec
                    id_lsoft
                    mes_recepcion
                    rut_receptor
                    rut_emisor
                    sucursal_codigo
                    tipo_dte_codigo
                    no_procesado
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.obtenerRecibidosImportacion;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerRecibidosIntercambioSII(
    inputParams: {
      empresa_rut: number;
      desde: Date;
      hasta: Date;
      tipo_dte_codigo: number;
      statusDocumento: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $desde: Date, $hasta: Date, $tipo_dte_codigo: Decimal, $statusDocumento: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documentoElectronico {
              obtenerRecibidosIntercambioSII(
                empresa_rut: $empresa_rut
                desde: $desde
                hasta: $hasta
                tipo_dte_codigo: $tipo_dte_codigo
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    fecha
                    folio
                    rut
                    razon_social
                    monto_neto
                    monto_exento
                    impuesto_adicional
                    total_bruto
                    intento_envio_al_sii
                    acuse_recibo
                    recepcion_mercaderia
                    respuesta_comercial
                    id_lsoft
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.obtenerRecibidosIntercambioSII;
        callback({ mensajes, respuesta });
      }
    );
  }

  EnviarEmitidoAcuseRecibo(
    inputParams: {
      empresa_rut: number;
      id_lsoft: number;
      type: 1;
      // Intercambio Empresas   =>  20: Acuse Recibo //, 21: Recepción Mercadería, 22: Respuesta Comercial
      // Intercambio SII        =>  30: Acuse Recibo, 31: Recepción Mercadería, 32: Respuesta Comercial
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $id_lsoft: Decimal, $type: Int) {
            documentoElectronico {
              enviarEmitidoAcuseRecibo(empresa_rut: $empresa_rut, id_lsoft: $id_lsoft, type: $type) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.enviarEmitidoAcuseRecibo;
        callback({ mensajes, respuesta });
      }
    );
  }

  enviarRecibidoAcuseRecibo(
    inputParams: {
      empresa_rut: number;
      id_lsoft: number;
      type: 1 | 2;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $id_lsoft: Decimal, $type: Int) {
            documentoElectronico {
              enviarRecibidoAcuseRecibo(empresa_rut: $empresa_rut, id_lsoft: $id_lsoft, type: $type) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.enviarRecibidoAcuseRecibo;
        callback({ mensajes, respuesta });
      }
    );
  }

  enviarRecibidoRecepcionMercaderia(
    inputParams: {
      empresa_rut: number;
      sucursal_codigo: number;
      id_lsoft: number;
    },
    callback: Function
  ) {
    console.log('enviarRecibidoRecepcionMercaderia', JSON.stringify(inputParams));
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $sucursal_codigo: Decimal, $id_lsoft: Decimal) {
            documentoElectronico {
              enviarRecibidoRecepcionMercaderia(empresa_rut: $empresa_rut, sucursal_codigo: $sucursal_codigo, id_lsoft: $id_lsoft) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.enviarRecibidoRecepcionMercaderia;
        callback({ mensajes, respuesta });
      }
    );
  }

  enviarRecibidoRespuestaComercial(
    inputParams: {
      empresa_rut: number;
      id_lsoft: number;
      result: 0 | 1 | 2;
      observacion: string;
      type: 1 | 2;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $id_lsoft: Decimal, $result: Int, $observacion: String, $type: Int) {
            documentoElectronico {
              enviarRecibidoRespuestaComercial(empresa_rut: $empresa_rut, id_lsoft: $id_lsoft, result: $result, observacion: $observacion, type: $type) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.enviarRecibidoRespuestaComercial;
        callback({ mensajes, respuesta });
      }
    );
  }

  urlPdfDocumentoEmitido(
    inputParams: {
      empresa_rut: number;
      id_lsoft: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $id_lsoft: Decimal) {
            documentoElectronico {
              urlPdfDocumentoEmitido(empresa_rut: $empresa_rut, id_lsoft: $id_lsoft) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.urlPdfDocumentoEmitido;
        callback({ mensajes, respuesta });
      }
    );
  }

  urlPdfDocumentoRecibido(
    inputParams: {
      empresa_rut: number;
      id_lsoft: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $id_lsoft: Decimal) {
            documentoElectronico {
              urlPdfDocumentoRecibido(empresa_rut: $empresa_rut, id_lsoft: $id_lsoft) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.urlPdfDocumentoRecibido;
        callback({ mensajes, respuesta });
      }
    );
  }

  confirmarDocumentosHaciaERP(
    inputParams: {
      empresa_rut: number;
      lista_id_lsoft: number[];
      periodo: Date;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $lista_id_lsoft: [Decimal], $periodo: Date) {
            documentoElectronico {
              confirmarDocumentosHaciaERP(empresa_rut: $empresa_rut, lista_id_lsoft: $lista_id_lsoft, periodo: $periodo) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.confirmarDocumentosHaciaERP;
        callback({ mensajes, respuesta });
      }
    );
  }

  noProcesarDocumentosHaciaERP(
    inputParams: {
      empresa_rut: number;
      lista_id_lsoft: number[];
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($empresa_rut: Decimal, $lista_id_lsoft: [Decimal]) {
            documentoElectronico {
              noProcesarDocumentosHaciaERP(empresa_rut: $empresa_rut, lista_id_lsoft: $lista_id_lsoft) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documentoElectronico.noProcesarDocumentosHaciaERP;
        callback({ mensajes, respuesta });
      }
    );
  }
}
